export function ProgressDisplay({ progress }: { progress?: number }) {
  if (!progress) return <>...</>;
  return <>{Math.floor((progress ?? 0) * 100) + "%"}</>;
}
